hrd.components.AbstractFieldComponent = hrd.components.AbstractComponent.extend({
	wrappableSelectors: '.field-container, .editable-data, .read-only-data, .button-with-addon, .select-minimal, .wrapper-for-ctc-btn',

	init: function(options) {
		var defaults = {
			impl: 'hrd.components.AbstractFieldComponent',
			type: 'abstract',
			mode: 'edit',
			name: undefined,
			id: undefined
		};
		this._super($.extend(true, {}, defaults, options));
	},
	isEditable: function() {
		return this.settings.mode === 'edit';
	},
	getFieldId: function() {
		return this.settings.id;
	},
	getFieldName: function() {
		return this.settings.name;
	},
	getFieldType: function() {
		return this.settings.type;
	},
	getFieldMode: function() {
		return this.settings.mode;
	},
	getFieldComposite: function(field) {
		let $composite = field.closest('.field-composite');
		return $composite;
	},
	/**
	 * Enhance Part
	 */
	enhanceField: function(field, id, klass) {
		this.log(`Component.enhanceField for "${this.settings.name} - ${this.settings.type} - ${this.settings.mode} - id: ${id}"`);
		this.settings.id = id;
		if (this.isEditable()) {
			const enhanced = this.enhanceEditField(field, id, klass);

			this.wrapForHelpAddon(field);

			$.timeout(0)
				.then(() => {
					this.wrapForGenericAddon(field);
				});

			return enhanced;
		} else {
			const enhanced = this.enhanceReadField(field, id, klass);

			this.wrapForHelpAddon(field);

			$.timeout(0)
				.then(() => {
					this.wrapForGenericAddon(field);
				});

			return enhanced;
		}
	},
	enhanceEditField: function(field, id, klass) {
		field.addClass(klass);
	},
	enhanceReadField: function(field, id, klass) {
		field.addClass(klass);
	},
	/**
	 * ReEnhance Part
	 */
	reEnhanceField: function(field) {
		let id = this.getFieldId();
		if (this.isEditable()) {
			return this.reEnhanceEditField(field, id);
		} else {
			return this.reEnhanceReadField(field, id);
		}
	},
	reEnhanceEditField: $.noop,
	reEnhanceReadField: $.noop,
	/**
	 * ReLoad Part
	 */
	reloadField: function(field) {
		let id = this.getFieldId();
		if (this.isEditable()) {
			return this.reloadEditField(field, id);
		} else {
			return this.reloadReadField(field, id);
		}
	},
	reloadEditField: $.noop,
	reloadReadField: $.noop,
	/**
	 * toObject Part
	 */
	toObject: function(field, object, options) {
		this.log(`Component.toObject for "${this.settings.name} - ${this.settings.type} - ${this.settings.mode}"`);
		let name = this.getFieldName();
		if (this.isEditable()) {
			this.getEditableField(field, name, object, options);
		} else {
			this.getReadOnlyField(field, name, object, options);
		}
	},
	getEditableField: function(field, name, object, options) {
		this.setValueByPath(object, name, field.val());
	},
	getReadOnlyField: function(field, name, object, options) {
		let value = field.data('current-value');
		if (value != undefined) {
			this.setValueByPath(object, name, value);
		} else {
			if (field.data('placeholder') != undefined) {
				this.setValueByPath(object, name, '');
			} else {
				this.setValueByPath(object, name, field.text());
			}
		}
	},
	/**
	 * toForm Part
	 */
	toForm: function(field, value, object, options) {
		this.log(`Component.toForm for ${this.settings.name} - ${this.settings.type} - ${this.settings.mode}`, value);
		if (this.isEditable()) {
			this.setEditableField(field, value, object, options);
		} else {
			this.setReadOnlyField(field, value, object, options);
		}
	},
	setEditableField: function(field, value, object, options) {
		field.val(value);
	},
	setReadOnlyField: function(field, value, object, options) {
		if (value != undefined) {
			let style = field.data('formatStyle');
			if (style) {
				let formattedVal = hrd.datatable.formatCellData.call(this, value, style);
				field.html(formattedVal);
			} else {
				field.text(value);
			}
		} else {
			field.text('');
		}
	},
	/**
	 * initForm Part
	 */
	initalizeComponent: function(field, initialValue) {
		this.log(`Component.initalizeComponent for "${this.settings.name} - ${this.settings.type} - ${this.settings.mode}"`, initialValue);
		field.val(initialValue);
	},
	initalizeComponentWithUndefined: function(field) {
		this.log(`Component.initalizeComponentWithUndefined for "${this.settings.name} - ${this.settings.type} - ${this.settings.mode}"`);
		// nothing to do
	},
	/**
	 * resetForm Part
	 */
	reset: function(field, options) {
		this.log(`Component.reset for "${this.settings.name} - ${this.settings.type} - ${this.settings.mode}"`);
		if (this.isEditable()) {
			this.resetEditableField(field, options);
		} else {
			this.resetReadOnlyField(field, options);
		}
	},
	resetEditableField: function(field, options) {
		field.val('');
	},
	resetReadOnlyField: function(field, options) {
		field.text('');
		let placeHolder = field.data('placeholder');
		if (placeHolder != undefined) {
			field.append($(`<span class="placeholder">${placeHolder}</span>`));
		}
	},
	/**
	 * Disable Field
	 */
	disableField: function(field, disable) {
		this.log(`Component.disableField for "${this.settings.name} - ${this.settings.type} - ${this.settings.mode}"`);
		field.attr('disabled', disable);
	},
	wrapForGenericAddon: function(field) {
		if (!field.usingChromaFlow()) return;

		if ((field.attr('data-type') === 'select' && field.attr('data-appearance') === 'minimal') || (field.attr('data-type') === 'select1' && field.attr('data-appearance') === 'minimal'))
			return;

		const $addon = field.closest('.field-composite').find('[data-variants~="addon"]');

		if ($addon.exists() && !$addon.closest('.addon-container').exists()) {
			$addon
				.add($addon.siblings(this.wrappableSelectors))
				.wrapAll('<div class="addon-container field-container"></div>');

			const $allElements = $addon.closest('.field-composite').find('*');
			const $fieldAndAddon = $allElements
				.filter((index, element) => $(element).is(field) || $(element).is($addon));

			if ($fieldAndAddon.get(0) && $fieldAndAddon.get(0) === $addon.get(0)) {
				$addon.addClass('addon-before');
			} else if ($fieldAndAddon.get(0) && $fieldAndAddon.get(0) === field.get(0)) {
				$addon.addClass('addon-after');
			}

			if ($fieldAndAddon.get(0) === field.get(0)) {
				field.addClass('addon-before');
			} else if ($fieldAndAddon.get($fieldAndAddon.length - 1) === field.get(0) || field.next().is('.help-addon.field-help-inline')) {
				field.addClass('addon-after');
			} else {
				field.addClass('addon-before addon-after');
			}
		}
	},
	wrapForHelpAddon: function(field) {
		if (!field.usingChromaFlow()) return;

		const fieldHelpKey = field.data('help');

		if (!fieldHelpKey) return;

		const fieldHelp = xlate(fieldHelpKey);
		const helpAppearance = field.data('help-appearance') || 'button';
		let $addon = field.closest('.field-composite').find('.help-addon');

		if (!$addon.exists()) {
			if (helpAppearance === 'button') {
				const $helpButton = $(`<button class="help-addon field-help-button"></button>`);

				field.after($helpButton);
				$helpButton.button({
					icons: {
						primary: 'f-icon far fa-question-circle',
					},
					text: false,
					disabled: false
				})
					.off('click.help')
					.on('click.help', (event) => {
						$helpButton.tooltip({
							items: ".field-help-button",
							content: () => fieldHelp,
							close: function(event, ui) {
								var me = this;
								ui.tooltip.hover(
									function() {
										$(this).stop(true).fadeTo('400', 1);
									},
									function() {
										$.timeout(2500).then(() => {
											$(this).fadeOut('400', function() {
												$(this).remove();
											});
										});
									}
								);
								ui.tooltip.on('remove', function() {
									$(me).tooltip("destroy");
								});
							},
						});
						$helpButton.tooltip('open');
					});
			} else {
				const $helpInline = `<div class="help-addon field-help-inline">${fieldHelp}</div>`;
				field.after($helpInline);
			}

			$addon = field.closest('.field-composite').find('.help-addon');
		}

		if ($addon.exists() && !$addon.closest('.help-addon-container').exists()) {
			$addon
				.add($addon.siblings(this.wrappableSelectors))
				.wrapAll(`<div class="help-addon-container help-${helpAppearance}-addon-container field-container"></div>`);
		}
	},
	/**
	 * Add tooltip to a field. Useful when a read text field has content not fully visible in the field
	 */
	applyTooltipIfNeeded: function(field) {
		let domField = field.get(0);
		let cw = domField.clientWidth;
		let sw = domField.scrollWidth;
		if (sw > cw) {
			field.attr('title', field.html()).tooltip();
		} else {
			let hasTooltip = field.data('tooltip') != undefined;
			if (hasTooltip) {
				field.removeAttr('title').tooltip('destroy');
			}
		}
	}
});